import { PageLayout } from "../../components/page-layout";
import { FileUpload } from "../../modules/file-upload";
import { useUser } from '../../store/auth/AuthSelectors';
import { CalculationNumberModal } from "./CalculationNumberModal";
import { ContinuePreviousUpload } from "./ContinuePreviousUpload";
import { DismissDraftDocumentModal } from "./DismissDraftDocument";
import { UploadOptionModal } from "./UploadOptionModal";
import { useUploadDocument } from "./useUploadDocument";

const ALLOWED_DC_UERS = ['rs8pu1', 'rszr6b', '*'];

export function UploadDocumentScreen() {
  const {
    onUpload,
    documents,
    loading,
    onContinueDraft,
    showDismissModal,
    showUploadOptionModal,
    closeDismissModal,
    openDismissModal,
    onDismiss,
    onSplitPdf,
    onDontSplitPdf,
    dismissFileUpload,
    onSyncWithDigitalCalculator,
    showCalculationNumberModal,
    closeCalculationNumberModal,
    getDocumentDigitalCalculator,
    gettingDocumentDigitalCalculator,
    isPDFUploaded,
  } = useUploadDocument();

  const user = useUser();

  if (!!documents && documents.length) {
    return (
      <PageLayout title="Upload Document(s)" backBtn loading={loading}>
        <ContinuePreviousUpload
          openModal={openDismissModal}
          onContinueDraft={onContinueDraft}
          type={
            documents.length && documents[0].uploadSessionId
              ? "Multiple"
              : "Single"
          }
        />
        <DismissDraftDocumentModal
          onDismiss={onDismiss}
          show={showDismissModal}
          onCancel={closeDismissModal}
        />
      </PageLayout>
    );
  }
  return (
    <PageLayout title="Upload Document(s)" backBtn loading={loading}>
      <FileUpload onUpload={onUpload} />
      <DismissDraftDocumentModal
        onDismiss={onDismiss}
        show={showDismissModal}
        onCancel={closeDismissModal}
      />
      <UploadOptionModal
        show={showUploadOptionModal}
        showSyncWithDC={ALLOWED_DC_UERS.includes(user?.username || '') || ALLOWED_DC_UERS.includes('*')}
        onSelectSplitFile={onSplitPdf}
        isPdf={isPDFUploaded}
        onSelectDontSplitFile={onDontSplitPdf}
        onDismissUpload={dismissFileUpload}
        onSyncWithDigitalCalculator={onSyncWithDigitalCalculator}
      />
      <CalculationNumberModal
        gettingDocumentDigitalCalculator={gettingDocumentDigitalCalculator}
        getDocumentDigitalCalculator={getDocumentDigitalCalculator}
        show={showCalculationNumberModal}
        onClose={closeCalculationNumberModal}
      />
    </PageLayout>
  );
}
